import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import config from '../../config';
import * as moment from 'moment';
import 'moment/locale/ja';
 // components
import Cell from './CalendarCell';
// style
import './index.css';
// for IE
// Without this, IE throws error "'Symbol' is not defined.".
import 'babel-polyfill';

const toErrPage = (errMsg) => {
    window.location.href = `index.html?msg=${window.btoa(encodeURIComponent(errMsg))}#/error`
}

export default class Calendar extends Component {
    

    constructor(props) {
        super(props);

        moment.locale('ja');

        let date = moment();
        date.endOf('month');

        // this.state = { modal: false, date , modalCalendar: true};
        this.state = { modal: false, date,}; 
    }




    componentDidMount() {
        const year = this.state.date.format('YYYY');
        const month = this.state.date.format('MM');
        this.fetchRecords(year, month);
    }

    fetchRecords = async (year, month) => {
        console.log(`call fetchRecors(${year}, ${month})`);
        let url = `${config.endpoint}/records/${year}/${month}`;
        let options = {
            headers: {
                
                'Authorization': `bearer ${this.props.user.token}`,
                'x-api-key': config.apikey,
                //'Authorization': `bearer ${this.props.user ? this.props.user.token : ''}`,
            }
        };
        return await axios.get(`${url}?_=${Date.now()}`, options).then(response => {
            // Add your code here
            // console.log('response', response.data);
            let items = response.data.reduce(function (map, item) {
                let day = moment(item.recordDate).format('DD');
                if (map[day]) {
                    map[day].push(item);
                } else {
                    map[day] = [item];
                }
                // map[day] = item;
                return map;
            }, {});

            let date = moment(`${year}-${month}-01`);
            date.endOf('month');

            this.setState({ date, items });
        }).catch(error => {
            console.log('error', error);
            toErrPage(error.response.data.message)
        });
    }

    renderRows() {
        const numberOfDate = this.state.date.date();

        let date = this.state.date.clone();
        let firstdayOfWeek = date.date(1).day(); // 当該月1日の曜日

        let rows = [];
        let day = 0;
        do {
            if (day === 0) {
                day = 1;
            } else {
                day += 7;

                // renderCellsのbaseDayが翌月になると最終週が描画されないため、月の最終日に変更
                if (numberOfDate < day){
                  day = numberOfDate;
                }
            }

            // console.log('row', day);
            rows.push(
                <div key={`row-${day}`} className="row">
                    {this.renderCells(day)}
                </div>
            );
        } while ((day + 7 - firstdayOfWeek - 1) < numberOfDate);

        return rows;
    }

    renderCells(baseDay) {
        let items = [];

        let currentMonth = this.state.date.month();
        let date = this.state.date.clone();
        date.date(baseDay);
        date.date(baseDay - date.day());

        for (let i = 0; i < 7; i++) {
            // console.log('cell', date);
            const key = date.format('YYYY-MM-DD');
            const day = currentMonth === date.month() ? date.format('DD') : '';
            let start = '';
            let end = '';
            if (this.state.items && this.state.items[day]) {
                const records = this.state.items[day];
                const record = records[0];
                start = record.startWork ? (record.startWork.time ? record.startWork.time : '--:--') : '';
                end = record.endWork ? (record.endWork.time ? record.endWork.time : '--:--') : '';
            }
            items.push(<Cell
                key={key}
                date={day}
                start={start}
                end={end}
                onClick={(e) => this.handleClickDate(e, key)} />);
            date.add(1, 'days');
        }

        return items;
    }


    

    renderModalbody() {
        const modalRecords = this.state.modalRecord;

        if (!modalRecords) {
            return null;
        }

        return (
            <ModalBody>
                <h5>出勤</h5>
                {((records) => {
                    let rows = [];

                    for (const record of records) {
                        let row = `${(record.startWork.time ? record.startWork.time : '--:--')} ~ `;
                        if (record.endWork) {
                            row += `${(record.endWork.time ? record.endWork.time : '--:--')}`;
                        }
                        rows.push(<div>{row}</div>);
                    }

                    return rows;
                })(modalRecords)}
                <h5 className="mt-3">休憩</h5>
                {((records) => {
                    let rows = [];
                    let index = 0;

                    for (const record of records) {
                        const items = record.breakTimeItems;
                        if (!items) continue;

                        for (const item of items) {
                            let row = `${item.start.time} ~ `;
                            if (item.end) {
                                row += item.end.time ? item.end.time : '--:--';
                            }
                            rows.push(<div key={index++}>{row}</div>);
                        }
                    }

                    return rows;
                })(modalRecords)}
            </ModalBody>
        );

    }

    render() {
       
        console.log("call render()", this.state);
        let formattedDate = this.state.date.format("YYYY/MM");

        document.getElementsByTagName("title")[0].innerText = "打刻";

        return (
            <div>
                <div className="calendar">
                    <div className="my-2">
                        <Button outline color="primary"
                            onClick={(e) => this.handleClickPrevButton(e)}>Prev</Button>
                        <span className="title mx-4">{formattedDate}</span>
                        <Button outline color="primary"
                            onClick={(e) => this.handleClickNextButton(e)}>Next</Button>
                    </div>
                    <div>
                        {this.renderRows()}
                    </div>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.handleClickDismiss}>
                    <ModalHeader toggle={this.handleClickDismiss}>{this.state.modalTitle}</ModalHeader>
                    {this.renderModalbody()}
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleClickDismiss}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    handleClickPrevButton = (event) => {
        event.preventDefault();
        let prevMonth = this.state.date.clone();
        prevMonth.add(-1, 'months');
        const year = prevMonth.format('YYYY');
        const month = prevMonth.format('MM');
        this.fetchRecords(year, month);
    }

    handleClickNextButton = (event) => {
        event.preventDefault();
        let nextMonth = this.state.date.clone();
        nextMonth.add(1, 'months');
        const year = nextMonth.format('YYYY');
        const month = nextMonth.format('MM');
        this.fetchRecords(year, month);
    }

    handleClickDismiss = (event) => {
        event.preventDefault();

        const newState = {
            modal: false,
            modalTitle: '',
            modalBody: '',
        };

        this.setState(newState);
    }

    handleClickDate = (event, date) => {
        console.log(`call handleClickDate(${date})`)
        event.preventDefault();

        const day = moment(date).format('DD');
        const newState = {
            modal: false,
            modalRecord: null,
            modalTitle: '',
            modalBody: '',
        };

        if (this.state.items && this.state.items[day]) {
            const records = this.state.items[day];
            newState.modal = true;
            newState.modalRecord = records;
            newState.modalTitle = moment(records[0].recordDate).format('YYYY年MM月DD日の勤怠');
            newState.modalBody = `<b>aa\na</b>`;
        }

        this.setState(newState);
    }}



// WEBPACK FOOTER //
// ./src/components/calendar/index.js